export default __webpack_public_path__ + "static/media/share-preview-twitter.2d60c245.png";